'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = uuid;

var _visualengineUtils = require('@ali/visualengine-utils');

var _lodash = require('lodash');

var _index = require('./i18n/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function uuid(uuidPrefix) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((typeof uuidPrefix === 'undefined' ? 'undefined' : _typeof(uuidPrefix)) === 'object') {
    uuidPrefix = '';
    options = uuidPrefix;
  }

  if (!uuidPrefix) uuidPrefix = 'vc_component';

  return _extends({
    name: 'fieldId',
    title: _index2.default.get({ id: 'uuidPropertyUniquelyIdentifies', dm: '唯一标识' }),
    display: 'inline',
    tip: _index2.default.get({
      id: 'uuidPropertyTheUniqueIdentifierOf',
      dm: '组件的唯一标识符，不能够与其它组件重名，不能够为空，且只能够使用以字母开头的，下划线以及数字的组合。'
    }),
    initialValue: function initialValue(value) {
      // if (typeof value === 'string' && value) return value;
      return _visualengineUtils.Util.uniqueId(value, (0, _lodash.camelCase)(uuidPrefix), 'fieldId');
    },

    setter: React.createElement(_visualengineUtils.TextSetter, {
      placeholder: _index2.default.get({ id: 'uuidPropertyPleaseEnterAUnique', dm: '请输入唯一标识' })
    })
  }, options);
}
module.exports = exports['default'];